module.exports = __webpack_public_path__ + "static/media/woman-in-app.403b589d.png";